/**
 * @generated SignedSource<<bc7f9878cf3db36927839756693080b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineEditAssignedRolesListItem_Dialog_roles$data = ReadonlyArray<{
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"RoleListItem_role">;
  readonly " $fragmentType": "RoutineEditAssignedRolesListItem_Dialog_roles";
}>;
export type RoutineEditAssignedRolesListItem_Dialog_roles$key = ReadonlyArray<{
  readonly " $data"?: RoutineEditAssignedRolesListItem_Dialog_roles$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineEditAssignedRolesListItem_Dialog_roles">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "RoutineEditAssignedRolesListItem_Dialog_roles",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoleListItem_role"
    }
  ],
  "type": "EmployeeRole",
  "abstractKey": null
};

(node as any).hash = "b778244f76e7c55ce723e34558db27d4";

export default node;
